import { TFormatted } from '../../types';

import { parseTkLiteral, TK_ID_ATTR, TK_MARKER_SELECTOR } from './recognition';

export interface ITkMarkerRef {
  noteId: string;
  /** Имя заметки как его видит автор — для строки списка. */
  noteName: string;
  /** Номер метки внутри своей заметки, считая по порядку текста. */
  ordinal: number;
  /** `data-tk-id`; может отсутствовать — уникальность id это лучшее усилие, не инвариант. */
  id: string | null;
  kind: string;
  payload: string;
}

/**
 * Проекция уже существующей разметки в плоский список меток.
 *
 * Это НЕ поиск по тексту. Метка создаётся в момент набора и хранится в HTML
 * заметки, поэтому здесь достаточно прочитать то, что уже записано. Отдельного
 * реестра меток нет намеренно: он был бы вторым источником правды и умел бы
 * разойтись с содержимым — а производная от содержимого разойтись с ним не может.
 *
 * Меткой считается ровно то же, что считает схема редактора: `span[data-tk-marker]`
 * с валидным литералом, и решает это тот же `parseTkLiteral`. Разъедься эти два
 * предиката — счётчик начал бы врать, а вся ценность панели в том, что ему верят.
 */
export function collectTkMarkers(entities: TFormatted[]): ITkMarkerRef[] {
  const parser = new DOMParser();
  const refs: ITkMarkerRef[] = [];

  entities.forEach((entity) => {
    const doc = parser.parseFromString(entity.originalContent ?? '', 'text/html');
    let ordinal = 0;

    doc.body.querySelectorAll(TK_MARKER_SELECTOR).forEach((element) => {
      const literal = parseTkLiteral(element.textContent ?? '');

      if (!literal) {
        return;
      }

      refs.push({
        noteId: entity.id,
        noteName: entity.originalName,
        ordinal,
        id: element.getAttribute(TK_ID_ATTR),
        kind: literal.kind,
        payload: literal.payload,
      });

      ordinal += 1;
    });
  });

  return refs;
}
